import {
  GET_SALE_ITEMS_LOCATIONS,
  GET_SALE_ITEMS_LOCATIONS_LOADING
} from 'store/actions/app/sale_items_locations.actions'

const initialState = {
  loading_sale_items_locations: false,
  sale_items_locations: {
    venta_info: null,
    items: []
  }
}

const saleItemsLocationsReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_SALE_ITEMS_LOCATIONS_LOADING:
      return {
        ...state,
        loading_sale_items_locations: action.payload
      }
    case GET_SALE_ITEMS_LOCATIONS:
      return {
        ...state,
        sale_items_locations: action.payload
      }
    default:
      return state
  }
}

export default saleItemsLocationsReducer
